import type { KeyboardEvent } from "react";

const PREVIOUS_KEYS = new Set(["ArrowLeft", "ArrowUp"]);
const NEXT_KEYS = new Set(["ArrowRight", "ArrowDown"]);

export function nextLocaleOptionIndex(
  key: string,
  currentIndex: number,
  optionCount: number,
): number | null {
  if (optionCount < 1) {
    return null;
  }
  if (key === "Home") {
    return 0;
  }
  if (key === "End") {
    return optionCount - 1;
  }
  if (PREVIOUS_KEYS.has(key)) {
    return (currentIndex - 1 + optionCount) % optionCount;
  }
  if (NEXT_KEYS.has(key)) {
    return (currentIndex + 1) % optionCount;
  }
  return null;
}

export function focusRadioAtIndex(
  event: KeyboardEvent<HTMLButtonElement>,
  index: number,
) {
  const radio = event.currentTarget.parentElement
    ?.querySelectorAll<HTMLButtonElement>('[role="radio"]')
    .item(index);
  radio?.focus();
}
